import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "geo-ip-redirect__container"
}
const _hoisted_2 = { class: "geo-ip-redirect__headers geo-ip-redirect__title-text" }
const _hoisted_3 = { class: "geo-ip-redirect__context-container" }
const _hoisted_4 = { class: "geo-ip-redirect__headers geo-ip-redirect__choose-country-text" }
const _hoisted_5 = { class: "geo-ip-redirect__language-and-continue" }
const _hoisted_6 = { class: "geo-ip-redirect__language-container" }
const _hoisted_7 = { class: "geo-ip-redirect__buttonsText geo-ip-redirect__select-button-icon" }
const _hoisted_8 = {
  key: 0,
  class: "geo-ip-redirect__channel-dropdown"
}
const _hoisted_9 = ["label", "value", "onClick"]
const _hoisted_10 = { class: "geo-ip-redirect__continue-container" }
const _hoisted_11 = { class: "geo-ip-redirect__buttonsText" }

import { inject, ref, onMounted, watch } from 'vue';
import { getItemKey } from '@drapejs/core';
import useContext from '@/composables/useContext';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useCountrySwitch from '@/composables/useCountrySwitch';
import { cartKey } from '@/keys';
import { getPrefferedCountryCookieValue } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoIpRedirect',
  setup(__props) {

const { mitt } = useContext();
const getItem = inject(getItemKey);
const cart = inject(cartKey, ref(null));

const { websiteText } = useWebsiteTexts();
const {
  buildRedirectUrl,
  activeCountryOption,
  geoIpCountryCode,
  setCountry,
  availableCountries,
  changeCountryError,
} = useCountrySwitch();

const isOpen = ref(false);
const isMenuOpen = ref(false);
const selectedChannel: any = ref({});
const transactionError = ref('');

const close = () => {
  sessionStorage.setItem('geoIpPopupDismissed', true.toString());
  isOpen.value = false;
  mitt.emit('geo-ip-popup', isOpen.value);
};

const selectChannel = (c) => {
  selectedChannel.value = c;
  isMenuOpen.value = false;
};

const onSetCountryRequest = async () => {
  try {
    transactionError.value = '';
    const { error, redirectUrl } = await setCountry(
      selectedChannel.value?.countryId
    );

    if (error === 'NONE') {
      const url = buildRedirectUrl(redirectUrl);
      close();
      if (redirectUrl) {
        window.location.assign(url);
      } else {
        window.location.reload();
      }
    } else {
      transactionError.value = changeCountryError.value;
    }
  } catch (err) {
    console.error(err);
    transactionError.value = changeCountryError.value;
  }
};

function getDefaultCountryOption(countryId) {
  const channel = availableCountries?.value?.find(
    (c) => c.countryId === countryId
  );
  if (channel) return channel;

  return availableCountries?.value?.[0];
}

function userSelectedCurrentCountry(activeCountryOption) {
  const userCountry = getPrefferedCountryCookieValue();

  if (!userCountry) {
    return false;
  }

  return activeCountryOption?.countryId == userCountry;
}

onMounted(async () => {
  let t = 0;
  const unwatch = watch(
    () => activeCountryOption?.value,
    async (val) => {
      clearTimeout(t);
      if (!val) return;

      if (
        sessionStorage.hasOwnProperty('geoIpPopupDismissed') ||
        !(availableCountries?.value?.length > 1) ||
        !geoIpCountryCode.value ||
        val.countryId === geoIpCountryCode.value ||
        userSelectedCurrentCountry(val) 
      ) {
        unwatch();
        return;
      }

      clearTimeout(t);
      t = setTimeout(() => {
        const defaultCountryOption = getDefaultCountryOption(
          geoIpCountryCode.value
        );

        if (defaultCountryOption) {
          selectedChannel.value = defaultCountryOption;
          unwatch();
          isOpen.value = true;
          mitt.emit('geo-ip-popup', isOpen.value);
        }
      }, 3000);
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('global__different_country', {
            country: _unref(activeCountryOption).name,
          }).value || 'global__different_country'), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('global__choose_country').value ||
            'global__choose_country'), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "geo-ip-redirect__buttons geo-ip-redirect__select-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(selectedChannel.value.name), 1)
                ]),
                (isMenuOpen.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableCountries), (channel) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["geo-ip-redirect__dropdown-menu-item", {
                  'geo-ip-redirect__dropdown-menu-item-selected':
                    channel.name === selectedChannel.value.name,
                }]),
                          label: channel.name,
                          value: channel.url,
                          onClick: ($event: any) => (selectChannel(channel))
                        }, _toDisplayString(channel.name), 11, _hoisted_9))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  onClick: onSetCountryRequest,
                  class: "geo-ip-redirect__buttons geo-ip-redirect__continue-button",
                  id: "geoIpContinue",
                  "data-cy": "geo-ip-redirect"
                }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(websiteText)('global__change_country_continue').value ||
                  'global__change_country_continue'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "geo-ip-redirect__close-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
          }, "×")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})